import type { ListState } from '@bemor/web-kit';
import { TagsField } from '@bemor/web-kit/ui';

/** BM-46 §2.5: the `tag[]` filter of the cases and merchants lists, as the tenant's colored tags (no creating here). */
export function TagFilter<Row>({ state }: { state: ListState<Row> }) {
    const raw = state.filters.tag;
    const value = Array.isArray(raw) ? raw : raw ? [raw] : [];
    return (
        <TagsField
            label="Tags"
            value={value}
            onChange={(ids) => state.setFilter('tag', ids.length ? ids : null)}
            canCreate={false}
            className="md:w-52"
        />
    );
}
